module.exports = __webpack_public_path__ + "static/printed2dim-560bf35b67770c65dd60204918cb2e34.png";